const axios = require('axios');

axios.interceptors.request.use(function(config) {
    config.headers.Authorization = `${localStorage.getItem('access_token')}`;

    return config;
}, function(error) {
    return Promise.reject(error);
});
